/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingopenpost2Inputs */

const en_crosspostingopenpost2 = /** @type {(inputs: Crosspostingopenpost2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open post`)
};

const de_crosspostingopenpost2 = /** @type {(inputs: Crosspostingopenpost2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitrag öffnen`)
};

/**
* | output |
* | --- |
* | "Open post" |
*
* @param {Crosspostingopenpost2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingopenpost2 = /** @type {((inputs?: Crosspostingopenpost2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingopenpost2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingopenpost2(inputs)
	return de_crosspostingopenpost2(inputs)
});
export { crosspostingopenpost2 as "crosspostingOpenPost" }